<template>
  <div id="live_submenu">
    <b-button :class="[currentTab === 'participants' ? 'active' : '']" class="inline-submenu-btn with_icon"
      @click="changeLiveTab('participants')">
      <b-icon icon="list-ul" aria-hidden="true"></b-icon>
      {{ $t("participants") }}</b-button>
    <b-button :class="[currentTab === 'passages' ? 'active' : '']" class="inline-submenu-btn with_icon"
      @click="changeLiveTab('passages')">
      <b-icon icon="geo" aria-hidden="true"></b-icon>
      {{ $t("passages") }}</b-button>
    <b-button :class="[currentTab === 'podium' ? 'active' : '']" class="inline-submenu-btn with_icon"
      @click="changeLiveTab('podium')">
      <b-icon icon="trophy" aria-hidden="true"></b-icon>
      {{ $t("podiums") }}</b-button>
    <b-button :class="[currentTab === 'carte_live' ? 'active' : '']" class="inline-submenu-btn with_icon"
      @click="changeLiveTab('carte_live')">
      <b-icon icon="map" aria-hidden="true"></b-icon>
      {{ $t("carte_live") }}</b-button>
    <b-button :class="[currentTab === 'webcam' ? 'active' : '']" class="inline-submenu-btn with_icon"
      @click="changeLiveTab('webcams')">
      <b-icon icon="camera-video" aria-hidden="true"></b-icon>
      {{ $t("webcams") }}
    </b-button>
    <b-button :class="[currentTab === 'favoris' ? 'active' : '']" class="inline-submenu-btn with_icon"
      @click="changeLiveTab('favoris')">
      <b-icon icon="star" aria-hidden="true"></b-icon>
      {{ $t("mes_favoris") }}
    </b-button>
  </div>
</template>

<script>
export default {
  props: ["currentTab"],
  data() {
    return {};
  },
  methods: {
    changeLiveTab(tab) {
      this.$store.state.last_live_tab = tab;
      this.$emit("changeLiveTab", tab);
    },
  },
};
</script>

<style lang="sass" scoped>
</style>